import { Component, Input, OnInit } from '@angular/core';
import { LicenseService } from '../../../services/license.service';
import { EnvironmentService } from '../../../services/environment.service';
import { BaseTileComponent } from '../tile.component';

@Component({
    selector: 'itpx-unknown-tile',
    templateUrl: './tile.component.html',
    styleUrls: ['./tile.component.css']
})

export class UnknownTileComponent extends BaseTileComponent implements OnInit {
    @Input() deliverable: any;

    private images : string;

    constructor(
        private licenseService: LicenseService,
        private environmentService: EnvironmentService
    ) {
        super();
    }

    ngOnInit() {
        this.images = this.environmentService.config['server'].images;
        super.complete(this.deliverable, true);
    }
}


// WEBPACK FOOTER //
// ./src/app/core/components/content/unknown/tile.component.ts